
import React from 'react';
import RepublicDay23 from 'views/RepublicDay23';

const ChildrensDayPage = () => {
  return <RepublicDay23 />;
};

export default ChildrensDayPage;
